module.exports = __webpack_public_path__ + "static/media/Depositphotos_63267181_xl-2015.37cd8e45.png";